import {IStore} from "modules/types";

export const getPrizesPopupStore = ({prize_popup}: IStore) => prize_popup;

export const getPrizesPopupData = ({prize_popup}: IStore) => prize_popup.data;

export const getPrizesPopupLoading = ({prize_popup}: IStore) => prize_popup.loading;
